import { type Context, type Input } from '../scrollspy-virtualized.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createInitialContext(params: { input: Input }): Context {
  return {
    activeTargetId: params.input.defaultTargetId,
    pendingTargetId: params.input.defaultTargetId,
    initialTargetId: params.input.defaultTargetId,
    listRef: params.input.listRef,
    findTargetIndex: params.input.findTargetIndex,
  };
}
